import { Inline, typography, Stack, Button, u } from '@ui';

import { errorStyle } from './ErrorFallback.css';

type ErrorFallbackProps = {
    error: unknown;
    resetError(): void;
};

export const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => {
    console.error(error);
    return (
        <div role="alert" className={errorStyle}>
            <Stack gap={u(2)} alignItems="center">
                <h2 className={typography({ variant: 'h2' })}>Something went wrong</h2>
                <p className={typography({ variant: 'p' })}>We're sorry for the inconvenience. Please try again.</p>
                <Inline gap={u(2)}>
                    <Button variant="primary" onClick={resetError}>
                        Reload
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            resetError();
                            window.history.back();
                        }}
                    >
                        Go Back
                    </Button>
                </Inline>
            </Stack>
        </div>
    );
};
